import { rem } from "polished";
import { styled } from "styled-components";

import { APP_GUTTER } from "styles";
import { LG_WIDTH } from "styles/theme/layout";

export const HeaderBarWrapper = styled.div`
  width: 100%;
  align-items: center;
  justify-content: space-between;
  background: ${({ theme }) => theme.colors.navy};
  color: ${({ theme }) => theme.colors.white};
  display: none;

  > a {
    width: 100%;
  }

  @media (min-width: ${LG_WIDTH}px) {
    display: flex;
    padding: 0 ${APP_GUTTER}px;
  }
`;

export const HeaderBarContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 40px;
  font-size: ${rem(12)};
`;

export const IndexText = styled.div`
  color: ${({ theme }) => theme.colors.cyan};
  font-size: ${rem(14)};
`;

export const HeaderPrice = styled.div`
  font-size: ${rem(14)};
  font-weight: 300;
  color: ${({ theme }) => theme.colors.white};
`;

export const HeaderChange = styled.div`
  font-size: ${rem(14)};
`;

export const HeaderDivider = styled.div`
  width: 1px;
  height: 15px;
  background: rgba(255, 255, 255, 0.2);
`;

export const ExplainerText = styled.span`
  color: rgba(255, 255, 255, 0.7);
`;

export const ExplainerLink = styled.span`
  color: ${({ theme }) => theme.colors.white};
  display: inline-block;
  text-decoration: underline;
  margin-left: 3px;
`;
